// Confirmation actions sometimes omit `fields`. Filtering that missing array
// rejects the click inside getDropdownData before the form opens.

export function dropdownFields(fields) {
    if (!Array.isArray(fields)) return [];
    return fields.filter((field) => field?.type === "dropdown");
}
